export const PROFILE_UPDATED_EVENT = 'profileUpdated';

export const triggerProfileUpdate = () => {
    window.dispatchEvent(new Event(PROFILE_UPDATED_EVENT));
}; 